import { InputAdornment } from "@mui/material";
import CoreTextField, { type CoreTextFieldProps } from "./TextField";
import CoreCopyButton from "../button/CopyButton";

type CopyOnlyTextFieldProps = Pick<CoreTextFieldProps, "id" | "value" | "ariaLabelledBy" | "placeholder"> & {
	copyButtonAriaLabel?: string;
};

export default function CopyOnlyTextField({
	id,
	value,
	copyButtonAriaLabel,
	ariaLabelledBy,
	placeholder,
}: CopyOnlyTextFieldProps) {
	return (
		<CoreTextField
			id={id}
			size="large"
			autoComplete="off"
			value={value}
			fullWidth
			ariaLabelledBy={ariaLabelledBy}
			placeholder={placeholder}
			InputProps={{
				readOnly: true,
				endAdornment: (
					<InputAdornment position="end" style={{ paddingRight: "6px" }}>
						<CoreCopyButton text={value?.toString() ?? ""} aria-label={copyButtonAriaLabel} />
					</InputAdornment>
				),
			}}
		/>
	);
}
